import translations from './translations'

translations.add('pt', {
    yourBrowserDoesNotSupportIFrames: 'O seu navegador não suporta iframes.'
})
